import React from 'react';

interface Props {
  stroke?: string;
}

const MenuIcon = (props: Props) => {
  const { stroke = '#5b5c5c' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      stroke={stroke}
      strokeWidth="3"   
      strokeLinecap="square"
      strokeLinejoin="inherit">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  );
}

export default MenuIcon;
